import React, { Component } from 'react';
import { closestParentByTagName } from '../../utils/html-helper';
import Keyboard, { KeyboardButton, LatinLayout } from 'react-screen-keyboard';
import { KeyboardContext } from '../../context/keyboard-context';

class KeyboardWrapper extends Component {
    static contextType = KeyboardContext;

    onSubmitClick = (parentForm, setActiveInput) => () => {
        const buttons = parentForm.getElementsByTagName('button');
        for (let i = 0; i < buttons.length; i++) {
            if (buttons[i].type === 'submit') {
                buttons[i].click();
                break;
            }
        }
        setActiveInput(null);
    };

    handleKeyboardWrapperClick = (event) => {
        event.preventDefault();
        if (this.context.activeInput) {
            this.context.activeInput.focus();
        }
    };

    renderKeyboard = (activeInput, setActiveInput) => {
        const parentForm = activeInput ? closestParentByTagName(activeInput, 'form') : null;
        const rightButtons = [];
        let className = 'sten-keyboard-wrapper';
        if (activeInput && window) {
            const rect = activeInput.getBoundingClientRect();
            if (rect.top > window.innerHeight / 2) {
                className += ' sten-keyboard-wrapper--top';
            }
        }
        if (parentForm) {
            const submit = this.onSubmitClick(parentForm, setActiveInput);
            rightButtons.push(
                <KeyboardButton
                    key="submit"
                    onClick={submit}
                    value="Submit"
                    classes="keyboard-submit-button"
                />
            );
        }
        return (
            <div
                className={className}
                onContextMenu={this.handleKeyboardWrapperClick}
                onMouseDown={this.handleKeyboardWrapperClick}
            >
                <Keyboard
                    key="Keyboard"
                    inputNode={activeInput}
                    layouts={[LatinLayout]}
                    rightButtons={rightButtons}
                />
            </div>
        );
    };

    render() {
        return this.context && this.context.activeInput
            ? this.renderKeyboard(this.context.activeInput, this.context.setActiveInput)
            : null;
    }
}

export default KeyboardWrapper;
